import React from 'react';
import { Typography } from '@material-ui/core';
import SearchField from '../Util/SearchField';
import DateRangePicker from '../Util/DateRangePicker';
import { Moment } from 'moment';
import SelectSingleUser from '../Util/SelectSingleUser';
import { TSession } from '../Sessions/Sessions';
import SelectSingleSession from '../Util/SelectSingleSession';

interface Props {
  search?: string;
  onSearchChange: (val: string) => void;
  timestampRange: { startDate: Moment | null; endDate: Moment | null };
  onTimestampRangeChange: (arg: { startDate: Moment | null; endDate: Moment | null }) => void;
  user?: string;
  onChangeUser: (user: string | undefined) => void;
  session?: TSession;
  onChangeSession: (session: TSession | undefined) => void;
}

const AuditFilter: React.FunctionComponent<Props> = (props) => {
  return (
    <div className="sciui-bg-p-4 sciui-m-y-m sciui-p-m">
      <div className="sciui-m-y-m">
        <Typography variant="h4">Filter</Typography>
      </div>
      <SearchField key="search" value={props.search} onChange={props.onSearchChange} />
      <DateRangePicker title="Timestamp" value={props.timestampRange} onChange={props.onTimestampRangeChange} />
      <SelectSingleUser value={{ id: props.user }} onChange={(user) => props.onChangeUser(user ? String(user.id) : undefined)} />
      <SelectSingleSession value={props.session} onChange={props.onChangeSession} />
    </div>
  );
};

export default AuditFilter;
